import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorMsg =
      (error?.message || '') +
      ' ' +
      (error?.rejection?.message || '') +
      ' ' +
      (error?.rejection?.toString?.() || '') +
      ' ' +
      (error?.toString?.() || '');

    const isChunkLoadError =
      /Loading chunk [\d]+ failed/i.test(errorMsg) ||
      /ChunkLoadError/i.test(errorMsg) ||
      errorMsg.includes('Failed to fetch dynamically imported module') ||
      errorMsg.includes('Importing a module script failed');

    if (isChunkLoadError) {
      const reloadKey = 'chunk_reload_attempted';
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      // Only auto-reload if not reloaded in the last 10 seconds (prevents infinite loop if chunk truly 404s permanently)
      if (!lastReload || now - Number(lastReload) > 10000) {
        sessionStorage.setItem(reloadKey, String(now));
        console.warn('ChunkLoadError detected due to new deployment. Auto-reloading application...');
        window.location.reload();
        return;
      }
    }

    // Default error logging
    console.error('Unhandled Application Error:', error);
  }
}
